import React, { FC } from 'react';
import { Link } from '@blueprint/ui';
import { Interpolate } from 'shared/i18n/Interpolate';

import registrationAndSignInTranslations from 'public/locales/en/registration-and-sign-in.json';
import { getTranslator } from 'shared/i18n/getTranslator';
import triggerTracking from '@blueprint/tracking/dist/Tracking';

import RegisterForm from './RegisterForm';
import { TermsText } from './../../AuthModal.styles';
import { SocialAuthProps } from './../../AuthModal.types';

const t = getTranslator(registrationAndSignInTranslations);
const termsAcceptanceTn = t('terms.acceptance');
const termsOfUseTn = t('terms.termsOfUse');
const termsPrivacyPolicyTn = t('terms.privacyPolicy');

const RegisterSection: FC<SocialAuthProps> = ({
    close,
    actionAfterAuth,
    resetActionAfterAuth,
    onSocialAuth
}) => (
    <>
        <RegisterForm
            close={close}
            actionAfterAuth={actionAfterAuth}
            resetActionAfterAuth={resetActionAfterAuth}
            onSocialAuth={onSocialAuth}
        />

        <TermsText size="secondary">
            <Interpolate
                template={termsAcceptanceTn}
                values={{
                    linebreak: <br key="linebreak" />,
                    termsLink: (
                        <Link
                            key="terms"
                            data-testid="terms-link"
                            href="/terms/"
                            onClick={() => {
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'registration',
                                    eventAction: 'click_to_terms',
                                    eventLabel: actionAfterAuth?.eventLabel
                                });
                            }}
                        >
                            {termsOfUseTn}
                        </Link>
                    ),
                    privacyLink: (
                        <Link
                            key="privacy"
                            data-testid="privacy-link"
                            href="/privacy/"
                            onClick={() => {
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'registration',
                                    eventAction: 'click_to_privacy',
                                    eventLabel: actionAfterAuth?.eventLabel
                                });
                            }}
                        >
                            {termsPrivacyPolicyTn}
                        </Link>
                    )
                }}
            />
        </TermsText>
    </>
);

export default RegisterSection;
